import { Reducer } from '@reduxjs/toolkit'

import { IPerformanceStats } from '../Client/IPerformanceStats'

import { ActionTypes, GET_PERFORMANCE_STATS_SUCCESS } from './ActionTypes'

interface IState {
  list: IPerformanceStats[]
}

const initialState: IState = {
  list: [],
}

export const performanceReducer: Reducer<IState, ActionTypes> = (
  state = initialState,
  action,
) => {
  switch (action.type) {
    case GET_PERFORMANCE_STATS_SUCCESS:
      return {
        ...state,
        list: action.payload.performanceReports,
      }
    default:
      return state
  }
}
